import { RestrictionReasonStoreStatic } from "./RestrictionReasonStoreStatic";
import { BondRegularPaymentStoreStatic } from "./BondRegularPaymentStoreStatic";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { LegadoConfigStoreStatic } from "./LegadoConfigStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const RestrictionNameDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const RestrictionReasonStore: RestrictionReasonStoreStatic = new RestrictionReasonStoreStatic();

export const BondRegularPaymentDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BondRegularPaymentStore: BondRegularPaymentStoreStatic = new BondRegularPaymentStoreStatic();

export const LegadoConfigDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const LegadoConfigStore: LegadoConfigStoreStatic = new LegadoConfigStoreStatic();